import React, { useState, useRef, useEffect } from 'react';
import './InfoHelper.css';

export default function InfoHelper({ text }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef]);

  return (
    <div className="info-helper-container" ref={containerRef}>
      <button 
        type="button" 
        className="info-helper-btn" 
        onClick={(e) => { e.preventDefault(); setOpen(!open); }}
        aria-label="Ajuda sobre este campo"
        title="Ajuda"
      >
        ?
      </button>
      {open && (
        <div className="info-helper-popover">
          <div className="info-helper-popover-arrow" />
          <div className="info-helper-popover-content">
            {text}
          </div>
        </div>
      )}
    </div>
  );
}

